const Loader = () => {
  return (
    <div className="flex h-max py-10 items-center justify-center bg-white w-full">
      <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent mx-auto"></div>
    </div>
  );
};

export default Loader;
